import PropTypes from 'prop-types'
import { isNullOrUndefined, isNullOrUndefinedOrEmpty } from 'utils'

const AmountWarn = ({ before, after, error }) => {
  const percentage =
    isNullOrUndefinedOrEmpty(before) || isNullOrUndefinedOrEmpty(after)
      ? 0
      : (after / before) * 100
  const fixed = Math.ceil(percentage.toFixed(1))
  return (
    percentage >= 500 &&
    before &&
    isNullOrUndefined(error) && (
      <span className="txt_error modify_error">
        변경 전 금액({before.toLocaleString()}원)의 {fixed.toLocaleString()}%로
        변경 후 금액 증가폭이 큽니다.
      </span>
    )
  )
}
AmountWarn.propTypes = {
  before: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  after: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  error: PropTypes.node,
}
export default AmountWarn
